import { joinParams } from '../utils'

export default {

  /**
   * 获取门店店长列表
   * @param chainId 门店Id
   * 文档地址:https://rap2.internal.xbed.com.cn/repository/editor?id=131&mod=237&itf=4679
   */
  getChainManagerList(chainId) {
    return this.instance.get('/roomChainManager', {
      params: {
        chainId: chainId
      }
    })
  },

  /**
   * 获取当前值班店长
   * @param chainId 门店Id
   * 文档地址:https://rap2.internal.xbed.com.cn/repository/editor?id=131&mod=237&itf=4680
   */
  getDutyManager(chainId) {
    return this.instance.get('/roomChainManager/dutyManager',{
      params: {
        chainId: chainId
      }
    })
  },

  /**
   * 切换值班店长
   * @param chainId 门店Id
   * @param userId 店长角色id
   * @param password 角色密码
   * @param operator 操作人
   * @param clientId 客户端1--小程序 、2--蓝主人 、3--丽家会Android ，4--丽家会iOS，5--OMS,6--XMS PC ，7--XMS 平板，8--XMS 掌柜，9--管家助手'
   * 文档地址:https://rap2.internal.xbed.com.cn/repository/editor?id=92&itf=4687
   */
  changeDutyManager(params) {
    return this.instance.put('/api/xms/roomChainManager/changeDuty', joinParams(params))
  },

  /**
   * 结束当前值班
   * @param chainId 门店Id
   * @param password 角色密码
   * @param operator 操作人
   * @param clientId 客户端1--小程序 、2--蓝主人 、3--丽家会Android ，4--丽家会iOS，5--OMS,6--XMS PC ，7--XMS 平板，8--XMS 掌柜，9--管家助手'
   * 文档地址:https://rap2.internal.xbed.com.cn/repository/editor?id=92&itf=4688
   */
  overDuty(params) {
    return this.instance.put('/api/xms/roomChainManager/overDuty', joinParams(params))
  }

}


// WEBPACK FOOTER //
// ./src/api/delegate.js